import baseService from "../services/BaseService";

export const getAllComments = async () => baseService.get("comments");
